import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {ButtonType} from "../../../types/button.type";
import {ThemeType} from "../../../types/theme.type";
import {ButtonSizeType} from "../../../types/button-size.type";

require('./bringoz-button.scss');
@Component({
  standalone: false,
  selector: 'bringoz-button',
  templateUrl: './bringoz-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozButtonComponent implements OnInit, OnChanges {
  @Input() text: string;
  // @Input() icon?: string;
  @Input() size: ButtonSizeType = ButtonSizeType.md;
  @Input() isDisabled: boolean;
  @Input() type?: ButtonType; // null, outline, tertiary
  @Input() theme: ThemeType = ThemeType.primary; // primary, secondary, success, info, warning ,danger;
  @Input() buttonType: string = 'button';

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  buttonClasses: string[] = [];

  constructor(@Inject(ElementRef) private elementRef: ElementRef, @Inject('$timeout') private $timeout) {}

  ngOnInit() {
    this.setButtonClasses();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.size || changes.type || changes.theme) {
      this.setButtonClasses();
    }
  }

  click(event){
    this.onClick.emit(event);
    this.$timeout(0).then(() => {});
  }

  private setButtonClasses() {
    this.buttonClasses = [
      `btn-${this.size || ButtonSizeType.sm}`,
      `btn${this.type ? `-${this.type}` : ''}-${this.theme || ThemeType.primary}`
    ];
    // this._setColorValue();
  }

  /*private _setColorValue() {
    const buttonElement = this.elementRef.nativeElement.querySelector('.btn');

    const computedStyles = window.getComputedStyle(buttonElement);

    const isOutline = this.type === 'outline';

    const outlineColor = computedStyles.getPropertyValue(`--bs-${this.theme}`);

    // should set white/black, by site theme:
    this.colorValue = isOutline ? outlineColor : 'white';

    if(this.type === 'tertiary') {
      this.colorValue = '#747474';
    }
  }*/
}
